//export const baseUrl = import.meta.env.REACT_APP_SERVICE_URL;
export const baseUrl = import.meta.env.REACT_APP_SERVICE_URL;
//export const baseUrl = 'https://sfaapidev.bfgsupply.com';

import { LOCAL_STORAGE_KEYS } from 'src/constants';
export const baseReactSiteUrl = import.meta.env.REACT_APP_BASE_REACT_URL;
export const baseWebApiUrl = import.meta.env.REACT_APP_WEBAPI_SERVICE_URL;
export const baseBFGReportUrl = import.meta.env.REACT_APP_BFG_REPORT_URL;

export async function postFile<T>(formdata, url): Promise<T> {
  return new Promise((resolve, reject) => {
    try {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', `${baseUrl}${url}`);
      xhr.withCredentials = true;
      xhr.onreadystatechange = () => {
        if (xhr.readyState == 4) {
          if (xhr.status === 200) {
            resolve(JSON.parse(xhr.responseText));
          } else {
            reject(xhr.statusText);
          }
        }
      };
      xhr.send(formdata);
    } catch (e) {
      reject(e);
    }
  });
}

async function handleResponse<T>(response: Response): Promise<T> {
  return new Promise<any>((resolve, reject) => {
    if (!response.ok) {
      if (response.redirected) {
        var matchUrl: RegExpMatchArray | null = response.url.match(/\/login\/.*$/);
        if (matchUrl) {
          window.location.href = baseReactSiteUrl + '/login/';
        }
      }

      reject(`Error fetching data: staus: ${response.status} - ${response.statusText}`);
      return;
    }

    // resolves the end of JSON error as noted in BFG-2528
    resolve(response.status === 204 ? true : response.json().catch((error) => reject(`Failed to parse JSON: ${error}`)));
  });
}

async function handleBlankResponse(response: Response) {
  return new Promise<void>((resolve, reject) => {
    if (!response.ok) {
      return reject(`Error on fetch call: staus: ${response.status} - ${response.statusText}`);
    }

    resolve();
  });
}

export async function get<T>(endpoint: RequestInfo): Promise<T> {
  const requestOptions: RequestInit = { method: 'GET', credentials: 'include' };
  const response = await fetch(baseUrl + endpoint, requestOptions);
  return handleResponse<T>(response);
}

export async function postRaw(endpoint, body: any): Promise<string> {
  return new Promise<string>((resolve) => {
    let xhr = new XMLHttpRequest();
    xhr.open('post', baseUrl + endpoint);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.withCredentials = true;
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        resolve(xhr.responseText);
      }
    };
    xhr.send(JSON.stringify(body));
  });
}

export async function post<T>(endpoint: RequestInfo, body: any): Promise<T> {
  const requestOptions: RequestInit = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
    credentials: 'include',
  };

  const response = await fetch(baseUrl + endpoint, requestOptions);
  return handleResponse<T>(response);
}

export async function postWebApi<T>(endpoint: RequestInfo, body: any): Promise<T> {
  const requestOptions: RequestInit = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Basic ${JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.AccessToken)).token}` },
    body: JSON.stringify(body),
    credentials: 'include',
  };

  const response = await fetch(baseWebApiUrl + endpoint, requestOptions);
  return handleResponse<T>(response);
}

export async function postExcelFile<T>(endpoint: RequestInfo, file: File): Promise<T> {
  let formData = new FormData();
  formData.append('file', file, file.name);

  const requestOptions: RequestInit = { method: 'POST', body: formData, credentials: 'include' };
  const response = await fetch(baseUrl + endpoint, requestOptions);

  return handleResponse(response);
}

export async function put(endpoint: RequestInfo, body: any): Promise<any> {
  const requestOptions: RequestInit = {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
    credentials: 'include',
  };

  const response = await fetch(baseUrl + endpoint, requestOptions);
  return handleBlankResponse(response);
}

export async function deleteImpl(endpoint: RequestInfo) {
  const requestOptions: RequestInit = { method: 'DELETE', credentials: 'include' };
  const response = await fetch(baseUrl + endpoint, requestOptions);

  return handleBlankResponse(response);
}

export async function getFile(endpoint: RequestInfo, fileName?: string, postBody?: any): Promise<Blob> {
  const isPost = postBody !== undefined;
  const requestOptions: RequestInit = {
    method: isPost ? 'POST' : 'GET',
    credentials: 'include',
    headers: isPost ? { 'Content-Type': 'application/json' } : undefined,
    body: isPost ? JSON.stringify(postBody) : undefined,
  };

  const response = await fetch(baseUrl + endpoint, requestOptions);

  if (!response.ok) {
    if (response.redirected) {
      var matchUrl: RegExpMatchArray | null = response.url.match(/\/login\/.*$/);
      if (matchUrl) {
        window.location.href = baseReactSiteUrl + '/login/';
      }
    }
    throw new Error(`Error fetching file: status: ${response.status} - ${response.statusText}`);
  }

  const blob = await response.blob();

  if (fileName) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  }

  return blob;
}

export default {
  postFile,
  get,
  postRaw,
  post,
  postExcelFile,
  postWebApi,
  put,
  delete: deleteImpl,
  getFile,
};
